<script setup>
import { useRoute } from '@js/utils/route';

const props = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    seoApikomContent: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();
function toggleAction() {
    axios
        .post(
            route(
                'front.projectManagement.seo.postToggleApikomContentProcessedAt',
                {
                    tenant: props.tenant.id,
                    id: props.seoApikomContent.id,
                },
            ),
        )
        .then(() => {
            if (props.callback) {
                props.callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" />
</template>
